import { BaseModel } from './base';

export class PayCategoryType extends BaseModel {
  payCategoryName: string;
  payCategoryDescription: string;
  subscriberId: string;
  siteId: string;
  id: string;
}
